import React from 'react'
import styled from 'styled-components'
import { IoIosQuote } from "react-icons/io";
import { AiOutlineStar } from "react-icons/ai";

const ClientSlider = (props) => {

  const { name, stars, disc, image, role, platform } = props.item;

  return (
    <Container>
      <Header>
        <span className='quote'><IoIosQuote /></span>

        <div>
          {Array(stars).fill().map((_, i) => (
            <span className='star' key={i}>
              <AiOutlineStar />
            </span>
          ))}
        </div>
      </Header>

      <Body>
        {disc}
      </Body>

      <Footer>
        <img src={image || `https://api.dicebear.com/7.x/initials/svg?seed=${name}&background=2b2b35&color=01be96`} alt={name} onError={(e) => {
    e.target.src = `https://ui-avatars.com/api/?name=${name}&background=2b2b35&color=01be96`;
  }} />

        <div className="details">
          <h1>~ {name}</h1>
          <p>{role}</p>
          <span className="platform">Verified on {platform}</span>
        </div>
      </Footer>
    </Container>
  )
}

export default ClientSlider

const Container = styled.div`
  background: linear-gradient(
    159deg,
    rgb(45, 45, 58) 0%,
    rgb(43, 43, 53) 100%
  );
  padding: 1.5rem 1rem;
  margin: 0 1rem;
  border-radius: 6px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .quote{
    font-size: 3rem;
    color: #01be96;
    opacity: 0.7;
  }

  .star{
    color: #ffcd3c;
    font-size: 1.3rem;
  }
`

const Body = styled.p`
  font-size: 0.85rem;
  margin-bottom: 1.5rem;
  min-height: 4rem;
  line-height: 1.5;
`

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  img{
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    object-fit: cover;
  }

  .details{
    display: flex;
    flex-direction: column;
  }

  h1{
    font-size: 1.1rem;
    font-weight: 700;

    @media(max-width:580px){
      font-size: 1rem;
    }

    @media(max-width:538px){
      font-size: 0.9rem;
    }
  }

  p{
    font-size: 0.75rem;
    color: rgba(255,255,255,0.6);

    @media(max-width:538px){
      font-size: 0.65rem;
    }
  }

  .platform{
    font-size: 0.7rem;
    color: #01be96;
    margin-top: 2px;
  }
`